import { isNil, get } from 'lodash';

/**
 * Gets the source id.
 *
 * @param {object} sourceObject - The source object.
 * @returns {string} The id for the source or empty string if not found.
 * @throws {Error} If source is null or undefined.
 */
export const getId = sourceObject => {
  if (isNil(sourceObject)) {
    throw new Error('source not defined');
  }
  return get(sourceObject, '_id', '');
};

/**
 * Get source name.
 *
 * @param {object} sourceObject - The source object.
 * @returns {string} The name of the source or empty string if not found.
 * @throws {Error} If source is null or undefined.
 */
export const getName = sourceObject => {
  if (isNil(sourceObject)) {
    throw new Error('source not defined');
  }
  return get(sourceObject, 'name', '');
};

/**
 * Gets the source's connector Id.
 *
 * @param {object} sourceObject - The source object.
 * @returns {string} The source's connector Id or empty string if not found.
 * @throws {Error} If source is null or undefined.
 */
export const getConnectorId = sourceObject => {
  if (isNil(sourceObject)) {
    throw new Error('source not defined');
  }
  return get(sourceObject, 'connectorId', '');
};

/**
 * Gets the source's layer name.
 *
 * @param {object} sourceObject - The source object.
 * @returns {string} The source's layer name or empty string if not found.
 * @throws {Error} If source is null or undefined.
 */
export const getLayerName = sourceObject => {
  if (isNil(sourceObject)) {
    throw new Error('source not defined');
  }
  return get(sourceObject, 'layerName', '');
};

/**
 * Gets the source's layer name.
 *
 * @param {object} sourceObject - The source object.
 * @returns {string} The source's layer name or empty string if not found.
 * @throws {Error} If source is null or undefined.
 */
export const getLayerNameSource = sourceObject => {
  if (isNil(sourceObject)) {
    throw new Error('source not defined');
  }
  return get(sourceObject, 'layerNameSource', '');
};

/**
 * Gets the source's attributes.
 *
 * @param {object} sourceObject - The source object.
 * @returns {string[]} The source's attributes or empty array if not found.
 * @throws {Error} If source is null or undefined.
 */
export const getAttributes = sourceObject => {
  if (isNil(sourceObject)) {
    throw new Error('source not defined');
  }
  return get(sourceObject, 'attributes', []);
};

/**
 * Checks if the source is deleted.
 *
 * @param {object} sourceObject - The  source object.
 * @returns {boolean} True if the  source is in trash, false otherwise.
 * @throws {Error} If  source is null or undefined.
 */
export const isDeleted = sourceObject => {
  if (isNil(sourceObject)) {
    throw new Error(' source not defined');
  }
  return get(sourceObject, 'deleted', '') !== 'no';
};

/**
 * Get sql query to consulting data.
 *
 * @param {object} sourceObject - The  source object.
 * @returns {boolean} True if the  source is in trash, false otherwise.
 * @throws {Error} If  source is null or undefined.
 */
export const getSQLQuery = sourceObject => {
  if (isNil(sourceObject)) {
    throw new Error(' source not defined');
  }
  return get(sourceObject, 'sqlQuery', '');
};
